import type { Hook } from '../types';
import styles from './buildTooltip.module.scss';
import { Legend } from '../../ui/legend/Legend';

/** @see https://echarts.apache.org/zh/option.html#tooltip */
export type Config = {
  extraCssText: string;
  backgroundColor: string;
  borderColor: string;
  borderWidth: number | number[];
  padding: number | number[];
  textStyle: {
    color: string;
    fontFamily: string;
    fontWeight: number | string;
    fontSize: number;
    lineHeight: number;
  };
  dvTitleStyle: {
    color: string;
    fontFamily: string;
    fontWeight: number | string;
    fontSize: number;
    lineHeight: number;
  };
};

export function buildTooltip(params: Parameters<Hook['buildTooltip']>[0]) {
  const { config } = params;
  const containerDom = document.createElement('div');
  const styleDom = document.createElement('style');
  containerDom.classList.add(styles.container);

  styleDom.textContent = `
    .${styles.container} {
      color: ${config?.textStyle?.color};
      font-family: ${config?.textStyle?.fontFamily};
      font-weight: ${config?.textStyle?.fontWeight};
      font-size: ${config?.textStyle?.fontSize}px;
      line-height: ${config?.textStyle?.lineHeight}px;
    }
    .${styles.title} {
      color: ${config?.dvTitleStyle?.color};
      font-family: ${config?.dvTitleStyle?.fontFamily};
      font-weight: ${config?.dvTitleStyle?.fontWeight};
      font-size: ${config?.dvTitleStyle?.fontSize}px;
      line-height: ${config?.dvTitleStyle?.lineHeight}px;
    }
  `;
  containerDom.appendChild(styleDom);

  if (params.noWrapper) {
    containerDom.classList.add(styles['no-wrapper']);
    containerDom.style.cssText += `
      background-color: ${config?.backgroundColor};
      border-color: ${config?.borderColor};
      border-width: ${
        Array.isArray(config?.borderWidth)
          ? config.borderWidth.map(i => `${i}px`).join(' ')
          : `${config?.borderWidth}px`
      };
      padding: ${
        Array.isArray(config?.padding)
          ? config.padding.map(i => `${i}px`).join(' ')
          : `${config?.padding}px`
      };
      ${config?.extraCssText};
    `;
  }

  if (params.title) {
    containerDom.appendChild(
      Legend.stringToDom(`<h6 class="${styles.title}">${params.title}</h6>`)
    );
  }

  const itemString = params.items
    .map(
      item => `
    <div class="${styles.item}">
      ${
        typeof item.type === 'undefined'
          ? ''
          : Legend.createIcon({ type: item.type, color: item.color, selected: true })
      }
      <span class="${styles['item-name']}">${item.name}</span>
      <span class="${styles['item-value']}">${item.value}</span>
    </div>
  `
    )
    .join('');

  containerDom.appendChild(Legend.stringToDom(`<div>${itemString}</div>`));

  // prettier-ignore
  return containerDom.outerHTML;
}

export default buildTooltip;
